import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyD8Yh-_bNgGdr5kk4bb-LKXX48lrLy7B7w",
  authDomain: "zeeplive-dcacf.firebaseapp.com",
  databaseURL: "https://zeeplivechat-dcacf-6fe47.firebaseio.com",
  projectId: "zeeplive-dcacf",
  storageBucket: "zeeplive-dcacf.appspot.com",
  messagingSenderId: "720604246001",
  appId: "1:720604246001:web:02e9dcd3a51b5db23e9e50"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
export const database = getDatabase(app);
